import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import { Tooltip } from '@mui/material';
import { NavLinkIconButtonWithRef } from '../../NavLinkIconButton/NavLinkIconButton';

import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { communicatorRoute } from '../../../../routes';

export default function HeaderActionsScheduleMessages() {
    const { classes } = useStyles();

    return (
        <Tooltip title="Schedule Messages">
            <NavLinkIconButtonWithRef pathname={communicatorRoute} className={classes.iconButton}>
                <PermPhoneMsgIcon />
            </NavLinkIconButtonWithRef>
        </Tooltip>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    iconButton: {
        padding: theme.spacing(1),
        '& .MuiSvgIcon-root': {
            fill: theme.palette.appHeader.contrastText,
        },
    },
}));
